import React from "react";
import clsx from "clsx";
import Assets from "imports/assets.import";
import PrimaryButton from "common_components/ui/primary_button/primary_button.ui";
import ChecklistItem from "common_components/ui/checklist_item/checklist_item.ui";
import { STRINGS } from "constants/strings.constant";
import { IMAGE_MAX_SIZE_MB, TARGET_IMAGE_MIN_HEIGHT, TARGET_IMAGE_MIN_WIDTH } from "utils/constant.utils";
import { ButtonTypes } from "utils/interface.utils";
import { EditorEmptyStateProps } from "interfaces/editor_empty_state.interface";
import "./editor_empty_state.component.scss";

const EditorEmptyState = (props: EditorEmptyStateProps) => {
    const { isFirstTarget, canAddTarget, onAddTarget, className } = props;
    const strings = STRINGS.editor.emptyState;

    // Built from the limits the upload dialog enforces, so the card cannot drift from them.
    const maxSizeRequirement = `${strings.requirementMaxSizePrefix} ${IMAGE_MAX_SIZE_MB} ${strings.requirementMaxSizeUnit}`;
    const minSizeRequirement = `${strings.requirementMinSizePrefix} ${TARGET_IMAGE_MIN_WIDTH} ${strings.requirementMinSizeSeparator} ${TARGET_IMAGE_MIN_HEIGHT} ${strings.requirementMinSizeUnit}`;

    return (
        <section className={clsx("editor_empty_state", className)}>
            <div className="editor_empty_state__header">
                <h2 className="editor_empty_state__title">{isFirstTarget ? strings.title : strings.laterTargetTitle}</h2>
                <p className="editor_empty_state__description">{isFirstTarget ? strings.description : strings.laterTargetDescription}</p>
            </div>

            <div className="editor_empty_state__tile">
                <div className="editor_empty_state__tile_icon">
                    <img src={Assets.image_upload} alt={strings.tileIconAlt} />
                </div>
                <div className="editor_empty_state__tile_text">
                    <span className="editor_empty_state__tile_title">{strings.addTargetTitle}</span>
                    <span className="editor_empty_state__tile_subtitle">{strings.addTargetSubtitle}</span>
                </div>
                {canAddTarget && (
                    <div className="editor_empty_state__action">
                        <PrimaryButton
                            text={strings.addButton}
                            left_icon={Assets.plus}
                            iconSize={{ width: 20, height: 20 }}
                            type={ButtonTypes.PRIMARY_GRADIENT}
                            className="editor_empty_state__button"
                            onClick={onAddTarget}
                        />
                    </div>
                )}
            </div>

            <div className="editor_empty_state__requirements">
                <ChecklistItem label={strings.requirementFormats} iconAlt={strings.requirementIconAlt} />
                <ChecklistItem label={maxSizeRequirement} iconAlt={strings.requirementIconAlt} />
                <ChecklistItem label={minSizeRequirement} iconAlt={strings.requirementIconAlt} />
            </div>
        </section>
    );
};

export default EditorEmptyState;
